<template>
  <v-app light>
    <v-toolbar app :clipped-left="clipped" flat absolute dark color="secondary">
      <v-toolbar-title class="margin-custom-width-left">
        <router-link :to="{name:'Home'}" style="text-decoration: none;" class="white--text">
          <h3>Fairfax City Futsal</h3>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn icon :to="{name :'Order'}" slot="activator">
          <v-icon>fa fa-shopping-cart</v-icon>
        </v-btn>
        <span>Buy Merchandise</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn icon :to="{name :'Contact'}" slot="activator">
          <v-icon>fa fa-envelope</v-icon>
        </v-btn>
        <span>Contact Fairfax City Futsal</span>
      </v-tooltip>

      <v-tooltip bottom class="margin-custom-width-right">
        <v-btn icon href="https://twitter.com/fairfax_futsal" target="_blank" slot="activator">
          <v-icon>fa fa-twitter</v-icon>
        </v-btn>
        <span>Twitter</span>
      </v-tooltip>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer class="margin-custom-width-left" color="secondary" dark :fixed="fixed" app>
      Fairfax City Futsal {{new Date().getFullYear()}}
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>
<style lang="stylus">
@media only screen and (min-width: 600px) {
  .margin-custom-width-left {
    padding-left: 10%;
  }
}

@media only screen and (min-width: 1264px) {
  .margin-custom-width-left {
    padding-left: 15%;
  }
}

@media only screen and (min-width: 1904px) {
  .margin-custom-width-left {
    padding-left: 20%;
  }
}

@media only screen and (min-width: 600px) {
  .margin-custom-width-right {
    padding-right: 10%;
  }
}

@media only screen and (min-width: 1264px) {
  .margin-custom-width-right {
    padding-right: 15%;
  }
}

@media only screen and (min-width: 1904px) {
  .margin-custom-width-right {
    padding-right: 20%;
  }
}
</style>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "App",
  data() {
    return {
      userRole: "guest",
      clipped: true,
      drawer: false,
      fixed: false,
      miniVariant: true,
      right: false,
      rightDrawer: false,
      title: "Fairfax City Futsal"
    };
  },

  methods: {
    moment,
    ...mapActions("account", { updateAccount: "update" }),
    ...mapActions("auth", { getToken: "getToken" })
  },

  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user"])
  },
  created() {
    let env = process.env.NODE_ENV || "development";

    //if (env === "production")
    {
      console.log(localStorage.getItem("token"));
     // if (localStorage.getItem("token") === null) {
        this.getToken().then(response => {
          localStorage.setItem("token", response);
        });
     // }
    }

    if (this.isLoggedIn) {
      this.user.lastLogIn = moment()
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");
      this.updateAccount(this.user);
      this.userRole = "user";
    } else {
      this.userRole = "guest";
    }
  }
};
</script>

<style>
* {
  text-transform: none !important;
}
</style>
